import React, { Component as C } from "react"

import classnames from "classnames"
import PropTypes from "prop-types"
import { isNil } from "ramda"

import styles from "../inputs.less"

class StatelessTextInput extends C {
  input = null

  componentDidMount() {
    if (this.props.autoSelectAll && !isNil(this.input)) {
      this.input.setSelectionRange(0, this.input.value.length)
    }

    if (this.props.autoSelectEnd && !isNil(this.input)) {
      this.input.setSelectionRange(this.input.value.length, this.input.value.length)
    }
  }

  handleChange(e) {
    this.props.onChange && this.props.onChange(e, e.target.value)
  }

  setRef = (ref) => {
    this.input = ref
    this.props.setRef && this.props.setRef(ref)
  }

  render() {
    const inputClass = classnames(styles.input, this.props.className, {
      disabled: this.props.disabled,
      [styles.notValid]: this.props.notValid,
      notValid: this.props.isNotValid,
    })

    return (
      <input
        ref={this.setRef}
        id={this.props.id}
        data-id={this.props.dataId}
        data-qa={this.props.dataQa}
        type={this.props.type}
        className={inputClass}
        value={this.props.value}
        onKeyUp={this.props.onKeyUp}
        onKeyDown={this.props.onKeyDown}
        onClick={this.props.onClick}
        onChange={this.handleChange.bind(this)}
        onCopy={this.props.onCopy}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        tabIndex={this.props.tabIndex}
        autoFocus={this.props.autoFocus}
        onFocus={this.props.onFocus}
        onBlur={(event) =>
          setTimeout(() => this.props.onBlur(event), 250)
        }
        maxLength={this.props.maxLength}
        name={this.props.name}
        readOnly={this.props.readOnly}
        min={this.props.min}
        max={this.props.max}
        autoComplete={this.props.autoComplete}
        role={this.props.role}
        title={this.props.title}
      />
    )
  }
}

StatelessTextInput.propTypes = {
  dataQa: PropTypes.string,
  dataId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  notValid: PropTypes.bool,
  tabIndex: PropTypes.number,
  autoFocus: PropTypes.bool,
  autoSelectAll: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onKeyUp: PropTypes.func,
  onChange: PropTypes.func,
  onCopy: PropTypes.func,
  onBlur: PropTypes.func,
  isNotValid: PropTypes.bool,
  maxLength: PropTypes.number,
  type: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  autoSelectEnd: PropTypes.bool,
  title: PropTypes.string,
}

StatelessTextInput.defaultProps = {
  type: "text",
}

export default StatelessTextInput
